// extracted by mini-css-extract-plugin
export var wordContainer = "_mh-0";